import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pcs-overlay',
  template: '<ng-content></ng-content>',
  styleUrls: ['./overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayComponent {
}
